var React = require('react');

function Loader (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"loader"),React.createElement("circle",{"cx":"50","cy":"50","fill":"none","stroke":"currentColor","strokeWidth":"8","r":"28","strokeDasharray":"131.94689145077132 45.982297150257104","key":1},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","repeatCount":"indefinite","dur":"1s","values":"0 50 50;360 50 50","keyTimes":"0;1"}))]);
}

Loader.defaultProps = {"viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"};

module.exports = Loader;

Loader.default = Loader;
